import React from 'react';
import {Route, Switch} from 'react-router-dom';

import * as routePaths from '../../consts/route/routePaths';
import BrowserVerificationPage from '../BrowserCompatibility/BrowserVerificationPage/BrowserVerificationPage';
import Root from '../Root/Root';
import TNC from '../TNC/TNC';
import WelcomePwaPage from '../WelcomePwaPage/WelcomePwaPage';
import AppRoute from './AppRoute';
import loadableRoutes from './loadableRoutes';

const Routes = () => {
    return (
        <Switch>
            <Route exact path={routePaths.ROOT} component={Root} />
            <AppRoute path={routePaths.ACTIVATION} component={loadableRoutes.DeviceActivationPage} />
            <AppRoute path={routePaths.AGE_GATE} component={loadableRoutes.AgeGatePage} />
            <AppRoute path={routePaths.AGE_VERIFICATION_FAILED} component={loadableRoutes.AgeVerificationFailedPage} />
            <AppRoute path={routePaths.APP_INTRO} component={loadableRoutes.AppIntroPage} />
            <AppRoute path={routePaths.WELCOME_PWA_PAGE} component={WelcomePwaPage} />
            <AppRoute path={routePaths.IMPORTANT} component={loadableRoutes.ImportantPage} />
            <AppRoute path={routePaths.BENEFIT_PAGE} component={loadableRoutes.BenefitPage} />
            <AppRoute path={routePaths.BROWSER_VERIFICATION} component={BrowserVerificationPage} />
            <AppRoute path={routePaths.CLEAN_TUTORIAL} component={loadableRoutes.CleaningGuidePage} />
            <AppRoute path={routePaths.CONNECTION_GUIDE_PARAMETRIZED} component={loadableRoutes.ConnectionGuidePage} />
            <AppRoute path={routePaths.LEGAL_DISCLAIMER} component={loadableRoutes.LegalDisclaimerPage} />
            <AppRoute path={routePaths.LOGIN} component={loadableRoutes.LoginPage} />
            <AppRoute path={routePaths.MY_DEVICES} component={loadableRoutes.MyDevicesPage} />
            <AppRoute path={routePaths.NO_DEVICES} component={loadableRoutes.NoDevicesPage} />
            <AppRoute path={routePaths.HOME_PAGE} component={loadableRoutes.HomePage} />
            <AppRoute path={routePaths.ERROR_PAGE} component={loadableRoutes.ErrorHandlingPage} />
            <AppRoute path={routePaths.NOT_COMPATIBLE_BROWSER} component={loadableRoutes.NotCompatibleBrowserPage} />
            <AppRoute path={routePaths.PAIRING_ALERT_PARAMETERIZED} component={loadableRoutes.PairingAlertPage} />
            <AppRoute path={routePaths.PAIRING_GUIDE_PARAMETERIZED} component={loadableRoutes.PairingGuidePage} />
            <AppRoute path={routePaths.PAIRING_SUCCESS} component={loadableRoutes.PairingSuccessPage} />
            <AppRoute path={routePaths.REGISTRATION} component={loadableRoutes.DeviceRegistrationPage} />
            <AppRoute path={routePaths.SYNC} component={loadableRoutes.DeviceSyncPage} />
            <AppRoute path={routePaths.RESET_DEVICE} component={loadableRoutes.ResetDevicePage} />
            <AppRoute path={routePaths.SELECT_DEVICE} component={loadableRoutes.SelectYourDevicePage} />
            <AppRoute path={routePaths.SELECT_MARKET} component={loadableRoutes.SelectMarketPage} />
            <AppRoute path={routePaths.TIPS_AND_TRICKS} component={loadableRoutes.TipsAndTricksPage} />
            <AppRoute
                path={routePaths.TIPS_AND_TUTORIALS_PARAMETERIZED}
                component={loadableRoutes.TipsAndTutorialsPage}
            />
            <AppRoute
                path={routePaths.QUICK_START_GUIDE_PARAMETERIZED}
                component={loadableRoutes.QuickStartGuidePage}
            />
            <AppRoute
                path={routePaths.TNC_DATA_PREFERENCE_SETTINGS}
                component={loadableRoutes.PreferenceCenterSettingsPage}
            />
            <AppRoute path={routePaths.TNC} component={TNC} />
            <AppRoute path={routePaths.WELCOME_USER} component={loadableRoutes.WelcomeUserPage} />
            <AppRoute path={routePaths.UPDATE_CHECKING} component={loadableRoutes.UpdateCheckingPage} />
            <AppRoute path={routePaths.UPDATE_SUMMARY} component={loadableRoutes.UpdateSummaryPage} />
            <AppRoute path={routePaths.UPDATE} component={loadableRoutes.UpdateFWPage} />
            <AppRoute path={routePaths.UP_TO_DATE_PARAMETERIZED} component={loadableRoutes.UpToDatePage} />
            <AppRoute path={routePaths.UP_TO_DATE_FAILED} component={loadableRoutes.UpToDateFailedPage} />
            <AppRoute
                path={routePaths.CONNECTION_SELECTION_PARAMETERIZED}
                component={loadableRoutes.ConnectionSelectionPage}
            />
            <AppRoute path={routePaths.DEVICE_SETTINGS} component={loadableRoutes.DeviceSettingsPage} />
        </Switch>
    );
};

export default Routes;
